module.exports = __webpack_public_path__ + "img/DSC_5617-min.5599ea52.jpg";